import api from "../../assests/skills_icons/api.png"
import database from "../../assests/skills_icons/database.png"
import laptop from "../../assests/skills_icons/laptop.png"
import star from "../../assests/skills_icons/star.png"
import web from "../../assests/skills_icons/web.png"
import app from "../../assests/skills_icons/app.png"


export const data = [
  {
    id: 1,
    image: laptop,
    heading: 'Programming Skills',
    description: "Proficient in C/C++, JavaScript, Object Oriented Programming"
  },
  {
    id: 2,
    image: api,
    heading: "Developer Tools",
    description: "Experienced with VS Code, Git, GitHub"
  },
  {
    id: 3,
    image: web,
    heading: "Web Development",
    description: "Skilled in ReactJs, HTML5, CSS3, JS, NodeJs, ExpressJs, MongoDb"
  },
  {
    id: 4,
    image: app,
    heading: "App Development",
    description: "Skilled in Flutter, Dart, MySql"
  },
  {
    id: 5,
    image: database,
    heading: "Databases & API Platforms",
    description: "Knowledgeable about MongoDB, Postman"
  },
  {
    id: 6,
    image: star,
    heading: "Design Tools",
    description: "Proficient in Figma for UI/UX design"
  },
]

export const heading = {
  webtitle: "Development covers websites and web apps, encompassing front-end, back-end, and full-stack expertise.",
  progtitle: "C++ offers powerful tools like classes, templates, and libraries (OOP)"
}

